/**
 * `mobileExcelUploadConfig` holds the organization IDs that have tic-sheets enabled
 */
const mobileExcelUploadConfig = import.meta.env.VITE_MOBILE_EXCEL_UPLOAD ? JSON.parse(import.meta.env.VITE_MOBILE_EXCEL_UPLOAD) : {};
export const mobileExcelUploadForOrganizations = mobileExcelUploadConfig?.organizationIds ?? [];

/**
 * `mobileAddressImportConfig` holds the organization IDs that have mobile address input enabled
 */
const mobileAddressImportConfig = import.meta.env.VITE_MOBILE_ADDRESS_UPLOAD ? JSON.parse(import.meta.env.VITE_MOBILE_ADDRESS_UPLOAD) : {};
export const mobileAddressImportForOrganizations = mobileAddressImportConfig?.organizationIds ?? [];
